module.exports = __webpack_public_path__ + "static/scale-model-of-toyota-tourist-in-plano-texas-06117ae2aca8c29d3f07c6d6440fa804.png";